import {IgnoredInputField, RequiredInputField, RegularInputField } from './InputFields.js';
import {StoredValue} from './StoredValue.js';

// .name, .label, .required, .type (hidden|select|[other]), .value, .options[]string
class VeedoUserLoginField {
	constructor(append, fldData) {
		this.data = fldData;

		//console.log(`creating new VeedoUserLoginField with `, fldData);

		if (`undefined`==typeof(fldData.value)) {
			fldData.value = ``;
		}
		this.value = new StoredValue(`veedo-login-${fldData.name}`, fldData.value);
		this.$ = new Object();
		this.$.label = document.createElement(`label`);
		this.$.label.innerText = fldData.label;
		append(this.$.label);
		if (this.data.required) {
			this.$.required = document.createElement(`span`);
			this.$.required.innerText = '*';
			this.$.required.classList.add(`required`);
			this.$.label.appendChild(this.$.required);
		} else {
			this.$.required = false;
		}
		switch (this.data.type) {
			case `hidden`:
				this.$.input = document.createElement(`hidden`);
				this.$.input.setAttribute(`type`,`hidden`);
				this.$.input.value = this.value.value;
				break;
			case `select`:
				this.$.input = document.createElement(`select`);
				// track the selected value
				let selectedValue = false;
				for (let o of this.data.options) {
					if (!selectedValue) {
						selectedValue = o;
					}
					let opt = document.createElement(`option`);
					opt.setAttribute(`value`, o);
					opt.innerText = o;
					if (o==this.value.value) {
						opt.setAttribute(`selected`,`selected`);
						selectedValue = o;
					}
					this.$.input.appendChild(opt);			
				}
				this.value.value = selectedValue;

				this.$.input.addEventListener(`change`, evt=>{
					this.value.value = this.$.input.options[this.$.input.selectedIndex].value;
					console.log(`set select field ${this.data.name} to ${this.value.value}`);
				});
				break;
			default:
				this.$.input = document.createElement(`input`);
				this.$.input.setAttribute(`type`, this.data.type);
				this.$.input.value = this.value.value;
				this.$.input.addEventListener(`change`, (evt)=>{
					this.value.value = this.$.input.value;
					console.log(`set field ${this.data.name} to ${this.value.value}`);
				});
				if (this.data.required) {
					this.$.input.setAttribute(`required`,`required`);
				}
				if (`undefined`!= typeof this.data.attrs) {
					for (let k in this.data.attrs) {
						this.$.input.setAttribute(k, this.data.attrs[k]);
					}
				}
				break;
		}
		append(this.$.input);
	}
	get Value() {
		return this.value;
	}
	get Valid() {
		if (!this.data.required) {
			return true;
		}
		return this.value.value;
	}
}

export class VeedoUserLogin {
	constructor(callback, config=false, failed=false) {
		console.log(`VeedoUserLogin`);
		
		if (!config) {
			config = new PlayerChatConfig();
		}
		this.addStyle();


		let dv = document.getElementById("veedo-user-login-frame");
		var div;
		if (dv){
			div = dv;
			div.computedStyleMap.display="block";
		} else {
			div = document.createElement(`div`);
			div.setAttribute(`id`, `veedo-user-login-frame`);
			div.innerHTML = `
	<div class="veedo-login-box">
		<div class="title" data-set="title">Chat Name</div>
		<div class="title">
			<img src="/img/CCNPF-LOGO.png" style="vertical-align:middle">
		</div>
		<div class="info" data-set="info">
			<div class="error" data-set="error"></div>
			<button data-set="register">login</button>
		</div>
	</div>
	`;
			let $ = {};
			for (let e of div.querySelectorAll(`[data-set]`)) {
				let n = e.getAttribute(`data-set`);
				$[n] = e;
			}

			if (failed){
				$.error.innerText = "Please supply a valid Sales Force Code!";

			}
			$.title.innerText = config.title;
			let insert = e=>$.info.insertBefore(e, $.register);

			this.fields = [];
			// MJH _ We need to check this!! undefined config.fields does the 'right thing'
			// even though it throws an error
			// but defined and empty it then presents the user with a 'login' button.
			for (let f of config.fields) {
				this.fields.push(new VeedoUserLoginField((el)=>{
					$.info.insertBefore(el, $.register);
				}, f));
			}
			const key = "player/base/settings";
			var settings = localStorage[key];
			if (!settings) {
				settings = {};
			} else {
				settings = JSON.parse(settings);
			}
			let name = ""
			if (settings.displayName) {
				name = settings.displayName; // 'name' is the only value we MUST HAVE in userSetting
			}
			if (localStorage["veedoanon"] && name == ""){
				$.register.disabled = true;
				let fld = this.fields[0];
				fld.$.input.disabled = true;
				document.addEventListener(`veedo-anon-name`, function(evt) {
					let vid = evt.detail;
					let parts = vid.split("-");
					let nid = parts[parts.length-1];
					nid = nid.replace(/0+/,"0");
					name = "anon"+nid;
					fld.value.value= name;
					fld.$.input.value = fld.value.value;
					$.register.disabled = false;
				})
			}

			$.register.addEventListener(`click`, evt=>{
				evt.preventDefault();
				let valid = this.fields.map( f=>f.Valid ).reduce( (v,a)=>v&&a , true);
				if (valid) {
					let fieldValues = new Object();
					for (let f of this.fields) {
						fieldValues[f.data.name] = f.value.value;
					}
					callback(fieldValues);
					div.remove();
				} else {
					console.log(`ERROR: did not get object validity - never called callback`);
				}
			});
			document.body.appendChild(div);
		}
	}
	addStyle() {
		if (document.getElementById(`veedo-user-login-style`)) {
			return;
		}
		let css = document.createElement(`style`);
		css.setAttribute(`id`, `veedo-user-login-style`);
		css.innerText = `
#veedo-user-login-frame {
	--color-primary: #fff; /* #0e700e; #0d132e;*/
	--color-fg: #333;

	position: fixed;
	top: 0; left: 0;
	bottom: 0; right: 0;

	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;

	background-color: rgba(0,0,0,0.6);

	font: roboto, sans-serif;
}
.veedo-login-box {
	background-color: white;
	filter: drop-shadow(2px 2px 8px #333);
}
.veedo-login-box label {
	font-size: 0.8em;
	color: #999;
	text-transform: uppercase;
}
.veedo-login-box>.title {
	color: white;
	background-color: var(--color-primary);
	padding: 0em;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content:center;
}
.veedo-login-box button {
	border: 1px solid var(--color-primary);
	background-color: transparent;
	text: var(--color-fg);
	transition: color 0.4s, background-color 0.4s;
	padding: 0.4em 1em;
	margin-top: 0.4em;
	text-transform: uppercase;
}
.veedo-login-box button:hover, .veedo-login-box button:active {
	background-color: var(--color-primary);
	color: white;
}
.veedo-login-box .info {
	background-color: #eee; /*#0d132e;*/
	display: flex;
	flex-direction: column;
	justify-content: flex-start;
	align-items: stretch;
	padding: 1em;
}
.veedo-login-box .info>* {
	margin-bottom: 0.6em;
}
.veedo-login-box .info>label {
	margin-bottom: 0;
}
.veedo-login-box label span.required {
	font-weight: bold;
	color: #966;
	margin-left: 0.4em;
}
.veedo-login-box .input-error {
	color: #966;
	font-size: 0.8em;
	font-weight: bold;
	text-transform: lowercase;
}
.veedo-login-box span.input-error.valid {
	display: none;
}`;
		document.head.appendChild(css);
	}

	url(u) {
		if (this.el && this.el.hasAttribute(`data-url`)) {
			u = this.el.getAttribute(`data-url`) + u;
		}
		return u;
	}
}